// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconFilledSaveHeart = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 24', fill: 'none', ...props },
    <path
      d="M21.375 12.347a5.422 5.422 0 001.04-6.32 5.587 5.587 0 00-8.884-1.422L12 6.001 10.47 4.605a5.586 5.586 0 00-8.885 1.422 5.42 5.42 0 001.04 6.32L12 22l9.375-9.653z"
      fill="currentColor"
    />
  );
export default SvgIconFilledSaveHeart;
